<script setup lang="ts">
import { VSkeletonBar } from '@/modules/shared/components'

// Layout-shaped placeholder for the SPV overview page during initial load.
// Mirrors the two-column structure shared by raising and closed/exited states
// so the page barely shifts when real data arrives. The KPI row is intentionally
// omitted because it is hidden in the raising state (would cause a downward
// shift on raising entities once data lands).
</script>

<template>
  <div aria-hidden="true">
    <div class="flex flex-col gap-5 lg:flex-row">
      <!-- Left column: deal/investment summary card -->
      <div class="min-w-0 lg:flex-[1.1]">
        <div class="overview-card">
          <div class="mb-4 flex flex-col gap-3">
            <VSkeletonBar width="128px" />
            <VSkeletonBar width="192px" />
            <VSkeletonBar width="75%" />
            <VSkeletonBar width="66%" />
          </div>

          <div class="flex flex-col gap-3 border-t border-gray-100 pt-3">
            <div v-for="row in 5" :key="row" class="flex items-center justify-between">
              <VSkeletonBar width="96px" />
              <VSkeletonBar width="128px" />
            </div>
          </div>
        </div>
      </div>

      <!-- Right column: two stacked cards -->
      <div class="min-w-0 space-y-5 lg:flex-1">
        <div class="overview-card">
          <div class="mb-4 flex flex-col gap-3">
            <VSkeletonBar width="144px" />
            <VSkeletonBar width="160px" />
            <VSkeletonBar width="100%" />
          </div>
          <div class="flex items-center justify-between gap-8">
            <div v-for="col in 3" :key="col" class="flex flex-col gap-1.5">
              <VSkeletonBar width="64px" />
              <VSkeletonBar width="48px" />
            </div>
          </div>
        </div>

        <div class="overview-card">
          <div class="mb-4">
            <VSkeletonBar width="128px" />
          </div>
          <div class="flex flex-col gap-3">
            <div v-for="row in 4" :key="row" class="flex items-center gap-3">
              <div class="h-7 w-7 flex-shrink-0 animate-pulse rounded-full bg-gray-200"></div>
              <div class="flex flex-1 flex-col gap-1.5">
                <VSkeletonBar width="75%" />
                <VSkeletonBar width="33%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
